export default __webpack_public_path__ + "static/media/caza3.63a7f5d3.svg";